import { IQ_API_BASE_URL, IQTECHMAX_ASSETS_BASE_URL } from "./constants.js";
import { loadPageOnResolve } from "./script.js";
import { makeCompatibleStyles } from "./styles-helper.js";

document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".carousel-track");
  const dotsNav = document.querySelector(".carousel-dots");
  const productImgs = document.querySelectorAll(".product-img");

  const productImagesArray = [
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/iq-agent.jpeg`,
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/iq-lens.jpeg`,
    `${IQTECHMAX_ASSETS_BASE_URL}/assets/images/iq-verse.jpg`,
  ];

  const updateTestimonial = async () => {
    return fetch(`${IQ_API_BASE_URL}/iqtechmax/testimonial?isActive=true`)
      .then(async (res) => {
        const data = await res.json();

        if (data.testimonials && data.testimonials.length > 0) {
          const container = document.getElementById("carouselSlide");
          container.innerHTML = "";

          data.testimonials.forEach((testimonial) => {
            const slide = document.createElement("div");
            slide.className = "carousel-slide";

            const card = document.createElement("div");
            card.className = "testimonial-card blur_card radial-hover-card";

            const radialContainer = document.createElement("div");
            radialContainer.className = "radial-hover-effect";

            const svg = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "svg"
            );
            svg.setAttribute("version", "1.1");
            svg.setAttribute("id", "Capa_1");
            svg.setAttribute("class", "quote-icon");
            svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
            svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
            svg.setAttribute("x", "0px");
            svg.setAttribute("y", "0px");
            svg.setAttribute("viewBox", "0 0 191.029 191.029");
            svg.setAttribute("xml:space", "preserve");

            const path = document.createElementNS(
              "http://www.w3.org/2000/svg",
              "path"
            );
            path.setAttribute(
              "d",
              `M44.33,88.474v15.377h38.417v82.745H0v-82.745h0.002V88.474c0-31.225,8.984-54.411,26.704-68.918
    C38.964,9.521,54.48,4.433,72.824,4.433v44.326C62.866,48.759,44.33,48.759,44.33,88.474z M181.107,48.759V4.433
    c-18.343,0-33.859,5.088-46.117,15.123c-17.72,14.507-26.705,37.694-26.705,68.918v15.377h0v82.745h82.744v-82.745h-38.417V88.474
    C152.613,48.759,171.149,48.759,181.107,48.759z`
            );

            svg.appendChild(path);

            const testimonialText = document.createElement("p");
            testimonialText.className = "testimonial-text";
            testimonialText.textContent = testimonial.quote;

            const testimonialStars = document.createElement("div");
            testimonialStars.className = "testimonial-stars";
            const rating = testimonial.rating;

            let starsHTML = "";
            for (let i = 1; i <= 5; i++) {
              starsHTML += i <= rating ? "★" : "☆";
            }

            testimonialStars.textContent = starsHTML;

            const authorDiv = document.createElement("div");
            authorDiv.className = "testimonial-author";

            const authorProfile = document.createElement("div");
            authorProfile.className = "author-profile blur_card";

            const authorProfileImg = document.createElement("img");
            authorProfileImg.src = testimonial.authorImageURL;
            authorProfileImg.alt = `${testimonial.author}-profile`;

            if (testimonial.authorImageURL)
              authorDiv.appendChild(authorProfile);

            const authorDetails = document.createElement("div");
            authorDetails.className = "author-details-wrapper";

            const authorName = document.createElement("p");
            authorName.className = "author-name";
            authorName.textContent = testimonial.author;

            const authorTitle = document.createElement("p");
            authorTitle.className = "author-title";
            authorTitle.textContent = testimonial.authorInfo;

            authorDetails.appendChild(authorName);
            authorDetails.appendChild(authorTitle);

            authorDiv.appendChild(authorDetails);

            card.appendChild(radialContainer);
            card.appendChild(svg);
            card.appendChild(testimonialText);
            card.appendChild(testimonialStars);
            card.appendChild(authorDiv);
            slide.appendChild(card);
            container.appendChild(slide);
          });
        }

        productImagesArray.forEach((img, index) => {
          productImgs[index].setAttribute("src", img);
        });
      })
      .then(() => {
        requestAnimationFrame(setupCarousel); // small delay ensures rendering is complete
      });
  };

  // ✅ Carousel setup function
  function setupCarousel() {
    const slides = Array.from(track.children);
    if (slides.length === 0) return;

    const slideWidth = slides[0].getBoundingClientRect().width;

    // 1. Set slide positions
    slides.forEach((slide, index) => {
      slide.style.left = slideWidth * index + "px";
    });

    // 2. Create dots
    dotsNav.innerHTML = "";
    slides.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.classList.add("carousel-dot");
      if (index === 0) dot.classList.add("current-slide");
      dotsNav.appendChild(dot);
    });

    const dots = Array.from(dotsNav.children);

    // 3. Move to Slide
    const moveToSlide = (currentTrack, targetSlide) => {
      const targetIndex = slides.indexOf(targetSlide);
      updateCarousel(targetIndex);
      currentTrack
        .querySelector(".current-slide")
        ?.classList.remove("current-slide");
      targetSlide.classList.add("current-slide");
    };

    const updateDots = (currentDot, targetDot) => {
      currentDot.classList.remove("current-slide");
      targetDot.classList.add("current-slide");
    };

    dotsNav.addEventListener("click", (e) => {
      const targetDot = e.target.closest("button.carousel-dot");
      if (!targetDot) return;

      const currentSlide = track.querySelector(".current-slide");
      const currentDot = dotsNav.querySelector(".current-slide");
      const targetIndex = dots.findIndex((dot) => dot === targetDot);
      const targetSlide = slides[targetIndex];

      moveToSlide(track, targetSlide);
      updateDots(currentDot, targetDot);
    });

    slides[0].classList.add("current-slide");
  }

  // Update the carousel transform to use enhanced handling
  function updateCarousel(index) {
    const transformValue = `translateX(-${index * 100}%)`;
    const compatibleStyles = makeCompatibleStyles({
      transform: transformValue,
    });
    Object.assign(track.style, compatibleStyles);
  }

  loadPageOnResolve(updateTestimonial);
});
